module.exports = new Promise((resolve, reject) => {
            const mfUrl = window.location.hostname === "localhost"
              ? "https://hondaplus.prod.mapit.me/sales-appointments"
              : window.location.origin + "/sales-appointments";
            import(mfUrl + "/assets/remoteEntry.js")
              .then(remote => {
                resolve({
                  get: (request) => remote.get(request).then(factory => {
                    // Vite federation returns () => module, call it to get module
                    return typeof factory === 'function' ? factory : () => factory;
                  }),
                  init: remote.init
                });
              })
              .catch(reject);
          });